import 'babel-polyfill';

import Vue from 'vue';
import axios from 'axios';
import toast from './lib/toast';
import loading from '@/lib/loading';
import APIS from './util/apis';
import getMP from './util/getMP'

import App from './App';
import {createStore} from './store';
import {createRouter} from './router';
import {sync} from 'vuex-router-sync';

import globalMixin from './mixins/globalMixin';
import titleMixin from './mixins/title-mixins';
import pageJumperMixin from './mixins/pageJumper-mixin';
import '@public/lib/Bridge';
import MetaInfo from 'vue-meta-info'
import { trackPlugin } from '@yxl/libs'

// 神策埋点
Vue.use(trackPlugin)

Vue.use(MetaInfo)
// }

/* xstream扩展 */
import {Stream} from 'xstream';
import {extendXstream} from '@/lib/xstream.extra';
import '@/lib/xstream.platform';
import '@/lib/dialog';
extendXstream(require('xstream'))

// import * as filters from './util/filters'

// Vue.config.productionTip = false;

Vue.prototype.$http = axios;
/* 拦截器配置 */
axios.defaults.withCredentials = true;
axios.defaults.headers['Content-Type']  = 'application/x-www-form-urlencoded;charset=UTF-8';  //此处是增加的代码，设置请求头的类型;
axios.interceptors.request.use(function (config) {
    config.params = config.params || {};
    config.params.appCode = 1;

    return config;
});
// 生产环境和服务端环境请求实际url
// if (process.env.NODE_ENV === 'production' || !!process.env.VUE_ENV/* typeof window === 'undefined' */) {
axios.interceptors.request.use(function (config) {
    config.url = config.url.replace(/\/api(?:\/)/, APIS.cpapiHost).replace(/\/qu(?:\/)/, APIS.quHost).replace(/\/lx(?:\/)/, APIS.lingxiHost);

    return config;
});

Stream.ajax.defaultSetting = {
    proxyError: true,
    toastAPI: toast, // 代理处理错误时，用到的toast方法
    httpAPI: axios, // http模块。
    retry: 2
};

var globalObject = {};
if (typeof window !== 'undefined') globalObject = window
else if (typeof global !== 'undefined') globalObject = global

if (true || !WEBPACK_DEV) {
    globalObject.Mock = require('mockjs');
    globalObject.Stream = Stream;
}


Vue.prototype.$toast = toast;
Vue.prototype.$loading = loading;

Vue.mixin(globalMixin);
Vue.mixin(titleMixin);
Vue.mixin(pageJumperMixin);

const isMp = getMP()
Vue.prototype.$getMP = window.$getMP = isMp
if (window.$getMP) {
  initMpSdk()
}
function initMpSdk() {
  const { loadScript } = require('@public/tools/loadScript')
  const userAgent = navigator.userAgent
  let thirdJs = ''
  if (userAgent.indexOf('AlipayClient') > -1) {
    thirdJs = `https://appx/web-view.min.js`
  } else if (/miniProgram/i.test(userAgent)) {
    console.log('=== 美团小程序加载 微信sdk ===')
    // 微信小程序 JS-SDK 如果不需要兼容微信小程序，则无需引用此 JS 文件。
    thirdJs = `https://res.wx.qq.com/open/js/jweixin-1.6.0.js`
  }

  const uniJs = `https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js`
  let loadUniScript = loadScript(thirdJs).then(() => {
    // 美团小程序不需要加载uni
    if (/miniProgram MMP/i.test(userAgent)) {
      // window.uni = window?.wx?.miniProgram
      window.uni = window.wx.miniProgram
    } else {
      loadScript(uniJs)
    }
  })

  function togo(nav, data = {}) {
    if (!nav) return {}
    let url = ''
    if (Object.prototype.toString.call(nav) === '[object Object]') {
      if (nav.path) {
        url = nav.path
      } else if (nav.name) {
        url = `/pages/${nav.name}/${nav.name}`
      }

      data = {
        ...nav.data,
        ...nav.query,
        ...nav.params
      }
    } else {
      url = nav
    }
    url += (url.indexOf('?') < 0 ? '?' : '&') + param(data)
    return {
      url
    }
  }

  function param(data) {
    let url = ''
    for (var k in data) {
      let value = data[k] !== undefined ? data[k] : ''
      url += '&' + k + '=' + value
    }
    return url ? url.substring(1) : ''
  }

  const push = function (nav, data = {}) {
    console.log('push', togo(nav, data))
    loadUniScript.then(() => {
      uni.navigateTo(togo(nav, data))
    })
  }

  const redirect = function (nav, data = {}) {
    console.log('redirect', togo(nav, data))
    loadUniScript.then(() => {
      uni.redirectTo(togo(nav, data))
    })
  }

  const login = function () {
    loadUniScript.then(() => {
      uni.navigateTo({
        url: '/pages/login/index',
      })
    })
  }

  Vue.prototype.$uniAppNavto = window.$uniAppNavto = {
    push,
    redirect,
    login,
  }
}

// import vconsole from 'vconsole';
// new vconsole()

// register global utility filters.
// Object.keys(filters).forEach(key => {
//   Vue.filter(key, filters[key])
// })

// Expose a factory function that creates a fresh set of store, router,
// app instances on each call (which is called for each SSR request)
export function createApp() {
    // create store and router instances
    const store = createStore()
    const router = createRouter()

    router.beforeEach((to, from, next) => {
        to.query.isCp = 1;
        next();
    })
    // sync the router with the vuex store.
    // this registers `store.state.route`
    sync(store, router)

    // create the app instance.
    // here we inject the router, store and ssr context to all child components,
    // making them available everywhere as `this.$router` and `this.$store`.
    const app = new Vue({
        router,
        store,
        render: h => h(App)
    })

    // expose the app, the router and the store.
    // note we are not mounting the app here, since bootstrapping will be
    // different depending on whether we are in a browser or on the server.
    return {
        app,
        router,
        store
    }
}



// WEBPACK FOOTER //
// ./src/main.js